// extracted by mini-css-extract-plugin
export var component = "Contracts-module--component--T6ahM";
export var contracts = "Contracts-module--contracts--glSrX";
export var description = "Contracts-module--description--9iQW8";